/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FindChargebackReportRequest} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'
import {FindChargebackReportResponse} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'


export const findChargebackReport = (request: FindChargebackReportRequest, options?: CashRequestOptions) => post<FindChargebackReportRequest, FindChargebackReportResponse>("/2.0/cash/find-chargeback-report", request, {...options, rejectOnError: true })